<ul class="popup popup-profile list" id="popup-profile" *ngIf="isVisible">
  <li><a routerLink="/settings" routerLinkActive="active">Настройки</a></li>
  <li><span class="link logout" (click)="logout()">Выход</span></li>
</ul>
